import { Controller } from "@hotwired/stimulus"

// Flashes the comment a notification pointed at, scrolling it into view first
// when the post above pushes it off screen. Waits a tick so Turbo's own
// scroll-to-top after rendering the page doesn't undo the reveal.
export default class extends Controller {
  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.timeout = setTimeout(() => this.reveal(), 0)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  reveal() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (!this.isOnScreen()) {
      this.element.scrollIntoView({ block: "center", behavior: reduceMotion ? "auto" : "smooth" })
    }

    this.element.animate(
      [
        { backgroundColor: "#fffbeb" },
        { backgroundColor: "#fffbeb", offset: 0.5 },
        { backgroundColor: "rgba(255, 251, 235, 0)" }
      ],
      { duration: 2400, easing: "ease-out" }
    )
  }

  isOnScreen() {
    const { top, bottom } = this.element.getBoundingClientRect()
    return top >= 0 && bottom <= window.innerHeight
  }
}
